import { createApiConstants } from '@saucelabs/sl-util-redux';

export const createCoverageTypes = (namespace) => {
  const createApiNamespacedConstants = createApiConstants.bind(null, namespace);

  return {
    CLEANUP: `${namespace}/CLEANUP`,
    INITIALIZED: `${namespace}/INITIALIZED`,
    CHANGE_SORTING: `${namespace}/CHANGE_SORTING`,
    GET_COVERAGE: createApiNamespacedConstants('GET_COVERAGE'),
    GET_COVERAGE_CSV: createApiNamespacedConstants('GET_COVERAGE_CSV'),
  };
};
